import { useEffect } from 'react';
import styled from 'styled-components';
import { MozartModal } from '@pgforsta/mozart_ui/lib/v4';
import ModalWrapper from '../styled/ModalWrapper';
import Table from '../styled/Table.js';
import { getSourceHistory } from '../../api/services/sources';
import useAsync from '../../hooks/async';

const Status = styled.p`
  margin: 20px 0;
  text-align: center;
`;

const HistoryModal = ({ source, onClose }) => {
  const query = useAsync();

  const { run, data: records } = query;

  useEffect(() => {
    if (!Boolean(source?.harvesterId)) {
      return;
    }
    run(getSourceHistory(source.harvesterId));
  }, [source, run]);

  const getHeaders = () => ['Description', 'Modified by', 'Modified on'];

  const getRows = () =>
    records.map((record) => [
      record.changeDescription,
      record.modifiedBy,
      record.modifiedOn,
    ]);

  return (
    <ModalWrapper contentPadding="0">
      <MozartModal
        show={Boolean(source?.harvesterId)}
        onClose={onClose}
        title="History"
        size="large"
      >
        {query.isIdle || query.isPending ? (
          <Status>Loading history...</Status>
        ) : query.isRejected ? (
          <Status>There was an error loading the history.</Status>
        ) : records.length === 0 ? (
          <Status>There are no records.</Status>
        ) : (
          <Table
            id="source-history-table"
            headers={getHeaders()}
            rows={getRows()}
          />
        )}
      </MozartModal>
    </ModalWrapper>
  );
};

export default HistoryModal;
